let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k8n99")).then(() => parcelRequire('3AnfB'));